import { TaskCard as TaskCardV1 } from "@coworker/apprestructured/src/tasks/components/TaskCard/TaskCard";
import TaskCardV2 from "@coworker/apprestructured/src/task-management/components/TaskCard/TaskCard";
import ListableTaskCardWrapper from "@coworker/apprestructured/src/task-management/components/TaskCard/wrappers/NormalTaskWrapper/ListableTaskCardWrapper";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { MediaTaskListItem } from "./types";

interface TaskCardRendererProps {
  taskListItem: MediaTaskListItem;
  itemsMap: Map<string, Item>;
  onV1TaskClick: (taskId: string, taskType: string) => void;
  onV2TaskClick: (taskListItem: MediaTaskListItem) => void;
}

export const TaskCardRenderer = ({
  taskListItem,
  itemsMap,
  onV1TaskClick,
  onV2TaskClick,
}: TaskCardRendererProps) => {
  const taskId = taskListItem.task.id;

  if (!taskId) return null;

  switch (taskListItem.type) {
    case "v1": {
      const item = itemsMap.get(taskListItem.task.product_article_id || "");
      // Skip rendering if item info not loaded yet
      if (!item) return null;

      return (
        <TaskCardV1
          key={taskId}
          // Type assertion: MediaTask is structurally compatible with FullTask for v1 rendering.
          // Both share core task fields (id, state, created_at, etc.) that TaskCardV1 uses.
          // Main difference: MediaTask.created_at is numeric, FullTask.created_at is string,
          // but TaskCardV1 handles both formats. This cast avoids creating a conversion adapter
          // for legacy v1 tasks that will eventually be phased out.
          // TODO: Remove when v1 tasks are fully migrated to v2 system.
          task={taskListItem.task as any}
          item={item}
          onShowTaskDetails={(taskId, taskType) =>
            onV1TaskClick(taskId, taskType)
          }
        />
      );
    }
    case "v2":
      return (
        <ListableTaskCardWrapper
          key={taskId}
          onSelect={() => onV2TaskClick(taskListItem)}
        >
          <TaskCardV2 task={taskListItem.task} />
        </ListableTaskCardWrapper>
      );
  }
};
